import React from 'react';
import { SvgIcon } from '@mui/material';

export default function OnlineIcon(props) {
  return (
    <SvgIcon viewBox="0 0 16 16" sx={{ width: 16, height: 16 }} {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.99935 8.66634C9.10392 8.66634 9.99935 7.77091 9.99935 6.66634C9.99935 5.56177 9.10392 4.66634 7.99935 4.66634C6.89478 4.66634 5.99935 5.56177 5.99935 6.66634C5.99935 7.77091 6.89478 8.66634 7.99935 8.66634Z"
          stroke="currentColor"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.99935 14.6663C10.666 11.9997 13.3327 9.61186 13.3327 6.66634C13.3327 3.72082 10.9449 1.33301 7.99935 1.33301C5.05383 1.33301 2.66602 3.72082 2.66602 6.66634C2.66602 9.61186 5.33268 11.9997 7.99935 14.6663Z"
          stroke="currentColor"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
